import getSafeReadableColor from './getSafeReadableColor';

export default function getButtonTextColor({
  buttonTextColor,
  buttonBackgroundColor,
  brandColor,
}) {
  if (buttonTextColor) {
    return buttonTextColor;
  }

  if (buttonBackgroundColor) {
    return getSafeReadableColor(buttonBackgroundColor);
  }

  if (brandColor) {
    return getSafeReadableColor(brandColor);
  }

  return '#FFFFFF';
}
